import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, MenuItem, Select, Typography, type SelectChangeEvent } from '@mui/material'
import { color } from 'config/color'
import { useAuth } from 'context'
import { useEffect, useState } from 'react'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'


interface ServiceAddressType {
    legacyAcctNumber: string
    premiseId: string
    serviceAddress: string
    accountId: string
    isGuestAccount?: boolean
}

export const ServiceAddress: React.FC = () => {
    const { account, handleCurrentAccount, handleIsGuestAccount, isGuestAccount, isLoggedInAsGuest } = useAuth()
    const [serviceAddresses, setServiceAddresses] = useState<ServiceAddressType[]>([])
    const [selectedAddress, setSelectedAddress] = useState<ServiceAddressType>({
        legacyAcctNumber: '',
        premiseId: '',
        serviceAddress: '',
        accountId: '',
        isGuestAccount: false
    })
    const isMobile = useMobileBreakpoints()
    const [isOpen, setIsOpen] = useState(false)

    useEffect(() => {
        if ((account?.myAccount?.serviceAddresses) != null) {
            const uniqueServiceAddresses = account.myAccount?.serviceAddresses.filter(
                (value, index, self) =>
                    self.findIndex((v) => v.accountId === value.accountId) === index
            )
            setServiceAddresses(uniqueServiceAddresses)
            setSelectedAddress(uniqueServiceAddresses[0])
        }
    }, [account])

    const handleChange = async (e: SelectChangeEvent): Promise<void> => {
        const tempAddress = serviceAddresses.find((address) => address.accountId === e.target.value)
            ; (tempAddress != null) && setSelectedAddress(tempAddress)
        if (tempAddress?.isGuestAccount === true) {
            handleIsGuestAccount(true)
        } else handleIsGuestAccount(false)

        handleCurrentAccount({ accountId: tempAddress?.accountId ?? '', premiseId: tempAddress?.premiseId ?? '' })
    }

    const formatServiceAddress = (serviceAddress: string, accountId: string): string => {
        const parts = serviceAddress?.split(',').map(part => part.trim()) || []
        const formatted = parts.length === 4 || parts.length === 3
            ? `${parts[0]}. ${parts[1]}`
            : parts[0]
        return `${formatted} | ${accountId}`
    }

    return (
        <> {
            isMobile
                ? <Box display="flex" flexDirection="column">
                    <Typography color={color.grey[700]} fontSize={12}>Service Addresss</Typography>
                    <Select variant="standard" value={selectedAddress?.accountId} onOpen={() => { setIsOpen(true) }} onClose={() => { setIsOpen(false) }} onChange={handleChange} disableUnderline={true} sx={{ fontSize: '16px' }} IconComponent={() => isOpen ? <ExpandLessIcon sx={{ color: color.primary[500] }} /> : <ExpandMoreIcon sx={{ color: color.primary[500] }} />}>
                        {serviceAddresses.length === 0 && (
                            <MenuItem value="">No active accounts</MenuItem>
                        )}
                        {serviceAddresses.length !== 0 && serviceAddresses.map((address: ServiceAddressType, index) => {
                            return (
                                <MenuItem key={index} value={address.accountId}>
                                    <Typography fontSize={14} textTransform="uppercase" noWrap>
                                        {formatServiceAddress(address.serviceAddress, address.accountId)}
                                    </Typography>
                                </MenuItem>
                            )
                        })}
                    </Select>
                </Box >
                : <Select
                    onOpen={() => { setIsOpen(true) }} onClose={() => { setIsOpen(false) }}
                    fullWidth
                    disabled={isGuestAccount && !isLoggedInAsGuest}
                    sx={{
                        fontSize: '14px',
                        color: color.white,
                        border: `solid 1px ${color.primary[800]}`,
                        borderRadius: '0px 0px 2px 2px'
                    }}
                    displayEmpty={serviceAddresses.length === 0}
                    value={selectedAddress?.accountId}
                    onChange={handleChange}
                    IconComponent={() => isOpen ? <ExpandLessIcon sx={{ color: color.primary[500] }} /> : <ExpandMoreIcon sx={{ color: color.primary[500] }} />}
                >
                    {serviceAddresses.length === 0 && (
                        <MenuItem value="">No active accounts</MenuItem>
                    )}
                    {serviceAddresses.length !== 0 && serviceAddresses.map((address: ServiceAddressType, index) => {
                        return (
                            <MenuItem key={index} value={address.accountId}>
                                <Typography fontSize={14} textTransform="uppercase" noWrap>
                                    {formatServiceAddress(address.serviceAddress, address.accountId)}
                                </Typography>
                            </MenuItem>
                        )
                    })}
                </Select>
        }
        </>
    )
}
